import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { TextBlockSectionComponentProps } from '../types';

export const TextBlockSectionGenerated: FC<
  TextBlockSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
